import AOS from 'aos';

$(function () {

    //
    setTimeout(() => {
        AOS.init({
            once: true,
            duration: 700,
            delay: 300
        });
    }, 100);

    //
    const $servicesItem = $('.services__item'),
        $servicesItemAnimEl = $('.services__item-content-bottom');

    if ($servicesItem.length > 0 && innerWidth > 767) {
        $servicesItem.mouseover(function () {
            $(this).find($servicesItemAnimEl).slideDown();
        });

        $servicesItem.mouseleave(function () {
            $(this).find($servicesItemAnimEl).slideUp();
        });
    }

    //
    const $expandItem = $('.js-expand-item');

    if ($expandItem.length > 0) {
        $expandItem.mouseenter(function () {
            $(this).siblings().removeClass('active');
            $(this).addClass("active");
        });

        $expandItem.first().addClass('active');

        function updateItemWidth() {
            let activeWidth = $expandItem.filter('.active').width();

            $expandItem.each(function() {
                $(this).find('.who-we-are__item-desc').width(activeWidth);
            });
        }

        setTimeout(() => { updateItemWidth(); }, 400);

        let resizeTimeout;
        $(window).resize(function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(updateItemWidth, 400);
        });
    }
});